function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.11055 10.707L6.7043 4.11016C6.85117 3.96328 7.08868 3.96328 7.23555 4.11016L13.8293 10.707C13.9762 10.8539 13.9762 11.0914 13.8293 11.2383L13.6074 11.4602C13.4605 11.607 13.2231 11.607 13.0762 11.4602L6.96992 5.35078L0.86055 11.457C0.713675 11.6039 0.476175 11.6039 0.3293 11.457L0.107425 11.2352C-0.036325 11.0914 -0.036325 10.8539 0.11055 10.707ZM0.11055 7.23828L0.332425 7.46016C0.4793 7.60703 0.7168 7.60703 0.863675 7.46016L6.96992 1.35078L13.0793 7.46016C13.2262 7.60703 13.4637 7.60703 13.6105 7.46016L13.8324 7.23828C13.9793 7.09141 13.9793 6.85391 13.8324 6.70703L7.23868 0.110156C7.0918 -0.0367187 6.8543 -0.0367187 6.70743 0.110156L0.11055 6.70703C-0.036325 6.85391 -0.036325 7.09141 0.11055 7.23828Z",
  fill: "#838383"
});

function SvgCollapse(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.f3030095.svg";
export { ForwardRef as ReactComponent };